module.exports = __webpack_public_path__ + "img/arena-1146.7ce590ed.png";